import {
  Box,
  Card,
  CardActions,
  CardContent,
  Container,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Parse from "../../API/ParseServer";
import styled from "styled-components";
import styles from "./Artwork.module.css";
import ArtworkTab from "../../Components/Tabs/ArtworkTab";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import Header from "../../Components/Layout/Header";
import load from "../../Assets/logo/FaamGallery-Page-Loader1-ezgif.com-gif-to-mp4-converter.mp4";
import Footer from "../../Components/Layout/Footer";
import ArtworkCard from "../../Components/ArtworkCard/ArtworkCard";
import { useCart } from "../../Context/CartContext";
import FluidGlass from "../../Components/UI/FluidGlass";

const Container2 = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  // padding: 50px;
  // border: 1px solid #00adb7;
  // border-radius: 5px;
  // :hover {
  //   box-shadow: 0 14px 24px rgba(0, 0, 0, 0.55), 0 14px 18px rgba(0, 0, 0, 0.55);
  // }
  // width: 100%;
  // height: 400px;
`;

const Image = styled.img.attrs((props: any) => ({
  src: props.source,
}))``;

const Target = styled(Image)`
  position: absolute;
  // width: 350px;
  left: ${(props: any) => props.offset.left}px;
  top: ${(props: any) => props.offset.top}px;
  opacity: ${(props: any) => props.opacity};
`;

const Artwork = () => {
  const params = useParams();
  const [artworkId, setArtworkId] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [mediumsDetail, setMediumsDetail] = useState("");
  const [framingImage, setFramingImage] = useState("");
  const [artist, setArtist] = useState("");
  const [picture, setPicture] = useState("");
  const [des, setDes] = useState([""]);
  const [price, setPrice] = useState(0);
  const [thumbnail, setThumbnail] = useState("");
  const [quantity, setQuantity] = useState(0);
  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);
  const [depth, setDepth] = useState(0);
  const [medium, setMedium] = useState([""]);
  const [style, setStyle] = useState([""]);
  const [theme, setTheme] = useState([""]);
  const [orientation, setOrientation] = useState("");
  const [deliveryTo, setDeliveryTo] = useState([""]);
  const [imageCount, setImageCount] = useState(0);
  const [imagesId, setImageId] = useState("");
  const [images, setImages] = useState([""]);
  const [selectedImage, setSelectedImage] = useState(0);
  const [artistPicture, setArtistPicture] = useState("");
  const [artistDes, setArtistDes] = useState([]);
  const [inputQuantity, setInputQuantity] = useState(1);
  const [similarArtworks, setSimilarArtworks] = useState<any>();
  const [alertMessage, setAlertMessage] = useState("");

  useEffect(() => {
    setLoading(true);
    const fetchArtwork = async () => {
      const query = new Parse.Query("Artwork");
      query.equalTo("objectId", params.artworkId);
      setArtworkId(String(params.artworkId));
      try {
        const results = await query.find();
        if (results.length > 0) {
          // console.log(results[0].id)
          setTitle(results[0].get("title"));
          setArtist(results[0].get("artist"));
          setPrice(results[0].get("price"));
          setThumbnail(results[0].get("thumbnail").url());
          setQuantity(results[0].get("quantity"));
          setHeight(results[0].get("height"));
          setWidth(results[0].get("width"));
          setDepth(results[0].get("depth"));
          setMedium(results[0].get("medium"));
          setStyle(results[0].get("style"));
          setTheme(results[0].get("theme"));
          setOrientation(results[0].get("orientation"));
          setDeliveryTo(results[0].get("deliveryTo"));
          setImageCount(results[0].get("imageCount"));
          setImageId(results[0].get("images"));
          //   setPicture(results[0].get("picture").url());
          setDes(results[0].get("description"));
          setDate(results[0].get("date"));
          setMediumsDetail(results[0].get("MediumsDetail"));
          setFramingImage(results[0].get("framingImage"));
          // setLoading(true);
          const imagesQuery = new Parse.Query("ArtworkImage");
          imagesQuery.equalTo("objectId", results[0].get("images").id);
          try {
            const imageResults = await imagesQuery.find();
            if (imageResults.length > 0) {
              // setArtworkId(results[0].id);
              let imageList = [];
              // imageList.push(thumbnail);
              for (
                let index = 1;
                index <= results[0].get("imageCount");
                index++
              ) {
                imageList.push(imageResults[0].get(`file${index}`).url());
                // console.log(results[0].get(`file${index}`).url());
              }
              setImages(imageList);
            } else {
              throw new Error("Artwork Images not found.");
            }
          } catch (err: any) {
            setError(err.message);
          } finally {
            setLoading(false);
          }
          const similarQuery: any = new Parse.Query("Artwork");

          if (results[0].get("artist") && results[0].get("theme")) {
            similarQuery._where = {
              $or: [
                { artist: results[0].get("artist") }, // Search in artistName
                { theme: { $in: results[0].get("theme") } },
              ],
            };
          }
          similarQuery.notEqualTo("objectId", results[0].id);
          similarQuery.limit(4);
          try {
            const similarResults = await similarQuery.find();
            if (similarResults.length > 0) {
              setSimilarArtworks(similarResults);
            } else {
              throw new Error("Artwork not found.");
            }
          } catch (err: any) {
            setError(err.message);
          } finally {
            // setLoading(false);
          }
        } else {
          throw new Error("Artwork not found.");
        }
      } catch (err: any) {
        setError(err.message);
      } finally {
        // setLoading(false);
      }
    };

    fetchArtwork();
  }, [params.artworkId, thumbnail]);

  useEffect(() => {
    const fetchArtist = async () => {
      const query = new Parse.Query("Artist");
      query.equalTo("name", artist);
      try {
        const results = await query.find();
        if (results.length > 0) {
          setArtistPicture(results[0].get("thumbnail").url());
          setArtistDes(results[0].get("biography"));
        } else {
          throw new Error("Artist not found.");
        }
      } catch (err: any) {
        setError(err.message);
      } finally {
        // setLoading(false);
      }
    };

    fetchArtist();
  }, [artist]);
  const [artworkItemId, setArtworkItemId] = useState("");
  const [artworkQuantities, setArtworkQuantities] = useState();
  const [basket, setBasket] = useState();
  const { setTotalQuantity } = useCart();
  useEffect(() => {
    const fetchBasket = async () => {
      const user = Parse.User.current();
      if (user || localStorage.getItem("guestId")) {
        try {
          const basket = await Parse.Cloud.run("getBasket", {
            user: user ? user.id : localStorage.getItem("guestId"),
          });
          if (basket.get("status") !== "completed") setBasket(basket);
          const artworkQuantities: any = {};
          basket
            .get("items")
            .filter(
              (item: any) =>
                item.type === "ArtworkFrame" || item.type === "Artwork",
            )
            .forEach((item: any) => {
              const artworkId = item.artwork.id;
              artworkQuantities[artworkId] =
                (artworkQuantities[artworkId] || 0) + item.quantity;
            });
          setArtworkQuantities(artworkQuantities);
          let totalQuantity = 0;
          basket.get("items").forEach((item: any) => {
            totalQuantity += item.quantity;
          });
          setTotalQuantity(totalQuantity);
          localStorage.setItem("totalQuantity", String(totalQuantity));
          // setBasket(basket);
          // if(basket)
          if (
            basket
              .get("items")
              .find(
                (item: any) =>
                  item.type === "Artwork" && item.artwork.id === artworkId,
              ) &&
            basket.get("status") !== "completed"
          ) {
            setInputQuantity(
              basket
                .get("items")
                .find(
                  (item: any) =>
                    item.type === "Artwork" && item.artwork.id === artworkId,
                ).quantity,
            );
            setArtworkItemId(
              basket
                .get("items")
                .find(
                  (item: any) =>
                    item.type === "Artwork" && item.artwork.id === artworkId,
                ).itemId,
            );
          }

          // console.log(
          //   basket
          //     .get("items")
          //     .find((item: any) => item.artwork.id === artworkId).quantity
          // );
        } catch (error) {
          console.error("Error fetching basket:", error);
        } finally {
          // setLoading(false);
        }
      }
    };
    fetchBasket();
  }, [artworkId]);
  const [artworkChange, setArtworkChange] = useState(false);
  const artworkChangeHandler = () => {
    setArtworkChange((current: any) => !current);
  };
  const sourceRef = useRef(null);
  const targetRef = useRef(null);
  const containerRef = useRef(null);

  const [opacity, setOpacity] = useState(0);
  const [offset, setOffset] = useState({ left: 0, top: 0 });

  const handleMouseEnter = () => {
    setOpacity(1);
  };

  const handleMouseLeave = () => {
    setOpacity(0);
  };

  const handleMouseMove = (e: any) => {
    const targetRect = (targetRef.current as any).getBoundingClientRect();
    const sourceRect = (sourceRef.current as any).getBoundingClientRect();
    const containerRect = (containerRef.current as any).getBoundingClientRect();

    const xRatio = (targetRect.width - containerRect.width) / sourceRect.width;
    const yRatio =
      (targetRect.height - containerRect.height) / sourceRect.height;

    const left = Math.max(
      Math.min(e.pageX - sourceRect.left, sourceRect.width),
      0,
    );
    const top = Math.max(
      Math.min(e.pageY - sourceRect.top, sourceRect.height),
      0,
    );

    setOffset({
      left: left * -xRatio,
      top: top * -yRatio,
    });
  };
  const imageClickHandler = (event: any) => {
    console.log(event.target.id);
    setSelectedImage(Number(event.target.id));
  };
  const navigate = useNavigate();

  const framingHandler = (event: any) => {
    localStorage.setItem("inputWidth", String(width));
    localStorage.setItem("inputHeight", String(height));
    localStorage.setItem("artworkId", String(params.artworkId));
    localStorage.setItem("framingMode", "artwork");
    navigate("/online-framing/new");
  };
  const quantityDecHandler = () => {
    setInputQuantity((current) => current - 1);
  };
  const quantityIncHandler = () => {
    setInputQuantity((current) => current + 1);
  };
  const uid = function () {
    return (
      Date.now().toString(36) +
      Math.floor(
        Math.pow(10, 12) + Math.random() * 9 * Math.pow(10, 12),
      ).toString(36)
    );
  };
  const addCartHandler = async () => {
    const user = Parse.User.current();
    if (user) {
      await Parse.Cloud.run("addToBasket", {
        user: user.id,
        artworkId,
        quantity: inputQuantity,
        frameId: "",
        specifications: {
          width,
          height,
          mountboard: {},
        },
        type: "Artwork",
        itemId: artworkItemId ? artworkItemId : "",
      });
      setAlertMessage("Artwork is added to you Cart");
      setTimeout(() => {
        setAlertMessage("");
      }, 1000);
      localStorage.removeItem("editItemId");
    } else {
      const guestId = localStorage.getItem("guestId")
        ? localStorage.getItem("guestId")
        : uid();
      await Parse.Cloud.run("addToBasket", {
        user: guestId,
        artworkId,
        quantity: inputQuantity,
        frameId: "",
        specifications: {
          width,
          height,
          mountboard: {},
        },
        type: "Artwork",
        itemId: artworkItemId ? artworkItemId : "",
      });
      setAlertMessage("Artwork is added to you Cart");
      setTimeout(() => {
        setAlertMessage("");
      }, 1000);
      localStorage.removeItem("editItemId");
      if (guestId) localStorage.setItem("guestId", guestId);
    }
  };
  function addCommas(num: number | String) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return (
    <Fragment>
      <Box sx={{ width: "100%", backgroundColor: "#f2f1f1" }}>
        <Container sx={{ py: 5 }}>
          <Box
            sx={{
              // marginTop: 15,
              borderBottom: "2px solid #dad9da",
              width: "100%",
              display: "flex",
              flexWrap: "wrap",
            }}
          >
            <Typography
              sx={{ display: "inline", color: "#999999", fontWeight: "bold" }}
            >
              All Products / {artist} /{" "}
            </Typography>
            <Typography
              sx={{
                display: "inline",
                boxShadow: "0 2px #0a0a0a",
                paddingBottom: "4px",
                fontWeight: "bold",
              }}
            >
              {title}
            </Typography>
          </Box>
          {loading ? (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                pt: 10,
              }}
            >
              <span className={styles.loader}></span>
            </Box>
          ) : (
            <Grid container sx={{ mt: 3 }}>
              <Grid
                item
                container
                md={8}
                xs={12}
                sx={{ display: "flex", justifyContent: "space-evenly" }}
              >
                <Grid
                  item
                  xs={1.4}
                  sx={{
                    overflow: "scroll",
                    height: "38rem",
                    display: { xs: "none", md: "flex" },
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  {images.map((image: string, index) => (
                    <img
                      src={image}
                      alt=""
                      className={
                        selectedImage === index
                          ? styles["selected-pic"]
                          : styles["unselected-pic"]
                      }
                      id={String(index)}
                      onClick={imageClickHandler}
                    />
                  ))}
                </Grid>
                <Grid item xs={12} md={9}>
                  {/* <Container2
                    ref={containerRef}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    onMouseMove={handleMouseMove}
                  >
                    <Image
                      ref={sourceRef}
                      alt="source"
                      source={images[selectedImage]}
                      style={{ width: "85%" }}
                    />
                    <Target
                      ref={targetRef}
                      alt="target"
                      opacity={opacity}
                      offset={offset}
                      source={images[selectedImage]}
                    />
                  </Container2> */}
                  <div
                    style={{
                      height: "600px",
                      position: "relative",
                      width: "100%",
                      overflow: "hidden",
                    }}
                    className={styles.glass}
                  >
                    <FluidGlass
                      mode="lens" // or "bar", "cube"
                      lensProps={{
                        scale: 0.3,
                        ior: 1.05,
                        thickness: 4,
                        chromaticAberration: 0,
                        anisotropy: 0,
                      }}
                      imageUrl={images[selectedImage]}
                      // barProps={} // add specific props if using bar mode
                      // cubeProps={} // add specific props if using cube mode
                      // mode="lens"
                      // scale={0.3}
                      // ior={1.2}
                      // thickness={1}
                      // transmission={1}
                      // roughness={0}
                      // chromaticAberration={0.14}
                      // anisotropy={0.03}
                    />
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{
                    overflow: "scroll",
                    display: { xs: "flex", md: "none" },
                    gap: 2,
                    mt: 3,
                  }}
                >
                  {images.map((image: string, index) => (
                    <img
                      src={image}
                      alt=""
                      className={
                        selectedImage === index
                          ? styles["selected-pic"]
                          : styles["unselected-pic"]
                      }
                      id={String(index)}
                      onClick={imageClickHandler}
                    />
                  ))}
                </Grid>
              </Grid>

              <Grid item md={4} xs={12} sx={{ mt: { xs: 4, md: 0 } }}>
                <Typography variant="h4" component="h1">
                  {title}
                </Typography>
                <Typography
                  component="h2"
                  sx={{ color: "#8d462b", display: "inline" }}
                  variant="h6"
                >
                  By{" "}
                </Typography>
                {artist !== "Faam Publication" &&
                artist !== "Faam Supplies" &&
                artist !== "Faam Branded" ? (
                  <Link to={`../artist/${artist}`}>
                    <Typography
                      component="h2"
                      sx={{
                        color: "#8d462b",
                        display: "inline",
                        textDecoration: "underline",
                      }}
                      variant="h6"
                    >
                      {artist}
                    </Typography>
                  </Link>
                ) : (
                  <Typography
                    component="h2"
                    sx={{
                      color: "#8d462b",
                      display: "inline",
                      textDecoration: "underline",
                    }}
                    variant="h6"
                  >
                    {artist}
                  </Typography>
                )}
                <br />
                <br />{" "}
                {des &&
                  des.map((item: string) => (
                    <Typography variant="subtitle1">
                      {item}
                      <br />
                    </Typography>
                  ))}
                <br />
                <br />
                {quantity > 0 ? (
                  <Typography
                    variant="h5"
                    sx={{ color: "#8d462b", fontWeight: "bold" }}
                    component="h2"
                  >
                    £{addCommas(price)}
                  </Typography>
                ) : (
                  <Typography
                    variant="h5"
                    sx={{ color: "red", fontWeight: "bold" }}
                    component="h2"
                  >
                    Sold!
                  </Typography>
                )}
                {quantity > 0 && (
                  <Fragment>
                    <br />
                    <br />
                    <Typography sx={{ color: "#8d462b", fontWeight: "bold" }}>
                      Quantity
                    </Typography>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <button
                        className={
                          inputQuantity === 1
                            ? styles["quantity-disable"]
                            : styles["quantity-button"]
                        }
                        onClick={quantityDecHandler}
                        disabled={inputQuantity === 1}
                      >
                        -
                      </button>
                      <Typography
                        sx={{
                          border: "2px solid #8d462b",
                          borderRadius: 2,
                          p: "2px 10px",
                          width: "2.5rem",
                          textAlign: "center",
                        }}
                      >
                        {inputQuantity}
                      </Typography>
                      <button
                        className={
                          inputQuantity >= quantity
                            ? styles["quantity-disable"]
                            : styles["quantity-button"]
                        }
                        onClick={quantityIncHandler}
                        disabled={inputQuantity === quantity}
                      >
                        +
                      </button>
                    </Box>
                    <br />
                    <br />
                    <Box
                      sx={{
                        display: "flex",
                        gap: 2,
                        alignItems: "center",
                        flexWrap: "wrap",

                        // justifyContent: { xs: "center", md: "start" },
                      }}
                    >
                      <button
                        className={styles.button}
                        onClick={addCartHandler}
                      >
                        Add to Cart
                      </button>
                      <Box sx={{ height: "1rem", width: "100%" }}>
                        {alertMessage && (
                          <Typography>{alertMessage}</Typography>
                        )}
                      </Box>
                      {framingImage && (
                        <button
                          className={styles.button}
                          onClick={framingHandler}
                        >
                          Have this Framed
                        </button>
                      )}
                    </Box>
                  </Fragment>
                )}
              </Grid>
            </Grid>
          )}
        </Container>
      </Box>
      <Container sx={{ mb: 3 }}>
        <ArtworkTab
          description={des}
          styles={style}
          mediums={medium}
          subjects={theme}
          mediumsDetail={mediumsDetail}
          year={Number(date)}
          sizes={[width, height, depth]}
        />
        {artist !== "Faam Publication" &&
          artist !== "Faam Supplies" &&
          artist !== "Faam Branded" && (
            <Grid container>
              <Grid
                item
                md={2}
                xs={12}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 3,
                }}
              >
                {artistPicture ? (
                  <img
                    src={artistPicture}
                    alt={artist}
                    style={{
                      backgroundColor: "gray",
                      maxWidth: "80%",
                      width: "10rem",
                      aspectRatio: 1,
                      borderRadius: "100%",
                    }}
                  />
                ) : (
                  <Box
                    sx={{
                      maxWidth: "80%",
                      width: "10rem",
                      aspectRatio: "1",
                      backgroundColor: "gray",
                      borderRadius: "100%",
                    }}
                  ></Box>
                )}
                <Link to={`../artist/${artist}`}>
                  <button className={styles.button}>View Profile</button>{" "}
                </Link>
              </Grid>
              <Grid item xs={12} md={10} sx={{ mt: 4, px: 1 }}>
                <Typography variant="h5" component="h2">
                  {artist}
                </Typography>
                <br />
                <Typography>{artistDes && artistDes[0]}</Typography>
              </Grid>
            </Grid>
          )}
        <Box
          sx={{
            mt: 5,
            borderBottom: "2px solid #dad9da",
            width: "100%",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              display: "inline",
              boxShadow: "0 2px #0a0a0a",
              paddingBottom: "4px",
            }}
          >
            Similar Artworks
          </Typography>
        </Box>
        <Grid container spacing={5} py={2}>
          {similarArtworks &&
            similarArtworks.map((artwork: any) => (
              <ArtworkCard
                artwork={artwork}
                basket={basket}
                artworkChangeHandler={artworkChangeHandler}
                artworkQuantities={artworkQuantities}
                grid={3}
              />
            ))}
        </Grid>
        {!similarArtworks && (
          <Typography sx={{ mt: 3, textAlign: "center" }} variant="h6">
            We have no similar Artworks
          </Typography>
        )}
      </Container>{" "}
    </Fragment>
  );
};

export default Artwork;
